import Modals from '../../../../shared/types/enums/modals';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import { store } from '../../../../shared/store/store';

const getModalStyle = () => {
  const { modal } = store.getState();
  switch (modal.current) {
    case Modals.PARENTAL_PIN_GENERIC:
      return {
        top: `${500 * Screen.widthRatio}px`,
      };
    case Modals.PARENTAL_PIN_ZAPPER:
      return {
        top: `${618 * Screen.widthRatio}px`,
      };
  }
  return '';
};

const ParentalPinInputContainer = styled.div<React.CSSProperties>`
  display: flex;
  left: 0;
  justify-content: center;
  margin: auto;
  position: absolute;
  right: 0;
  width: ${740 * Screen.widthRatio}px;
  ${() => getModalStyle()}
`;

export default ParentalPinInputContainer;
